/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { ReactNode } from "react";

export interface PageHeaderProps {
    title?: ReactNode;
    children?: React.ReactNode;
    breadcrumbs?: React.ReactNode;
}

export const PageHeader = ({ children, title, breadcrumbs }: PageHeaderProps) => {
    return (
        <div className="w-100 d-flex flex-column gap-3 gap-md-5 pt-3 pt-md-5" css={css`margin-bottom: 4rem;`}>
            <div className="d-flex flex-column gap-2">
                {breadcrumbs && breadcrumbs}

                {typeof title === "string" ? <h3 className="mb-0">{title}</h3> : title}
            </div>

            {children}
        </div>
    );
};
